export default function Tracking() {
  const cookieYesId = process.env.NEXT_PUBLIC_COOKIEYES_ID || '1fe695c49938651559b3e070439b36d6';
  return (
    <>
      {/* CookieYes Banner */}
      {cookieYesId && (
        <script id="cookieyes" type="text/javascript" src={`https://cdn-cookieyes.com/client_data/${cookieYesId}/script.js`} />
      )}
      {/* End CookieYes Banner */}

      {/* BE Autopilot */}
      {/* <script src="//cdn.bc0a.com/autopilot/f00000000293000/autopilot_sdk.js" /> */}
      {/* End BE Autopilot */}
    </>
  );
}
